export default __webpack_public_path__ + "static/platform_screenshot-crop_entities-view-17e94aa968bb4d9ef4743451145aa617.webp";